import Backbone from 'backbone'
import _ from 'lodash'

var messageBus = (document.messageBus = _.extend({}, Backbone.Events))

export default messageBus
